var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-layout"},[_c('div',{staticClass:"lt"},[_vm._t("default")],2),_c('div',{staticClass:"rt"},[(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }